import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { QuestionnaireState } from "../types/api";
import { getQuestions } from "../api/userApi";
import useProfileStore from "./useProfileStore";

const loadFromLocalStorage = <T>(key: string, defaultValue: T) => {
  const saved = localStorage.getItem(key);
  return saved ? JSON.parse(saved) : defaultValue;
};

const useQuestionnaireStore = create<QuestionnaireState>()(
  devtools(
    (set) => ({
      questions: loadFromLocalStorage("questions", null),
      loading: false,
      error: null,

      fetchQuestions: async (token: string) => {
        set({ loading: true, error: null });

        try {
          const language = useProfileStore.getState().profileLanguage;
          const langKey = language ? Object.keys(language)[0] : "en";
          const response = await getQuestions(langKey);
          if (!response) {
            throw new Error("Failed to fetch goals");
          }
          set({ questions: response.data, loading: false });
          localStorage.setItem("questions", JSON.stringify(response.data));
        } catch (error: any) {
          set({ error: error.message, loading: false });
        }
      },
    }),
    { name: "questionnaireStore" }
  )
);

export default useQuestionnaireStore;
